/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceInUseDto } from '../../models/device-in-use-dto';

export interface UpdateGroupDevices_1$Params {
  groupIdx: number;
  harvestId: number;
      body: Array<DeviceInUseDto>
}

export function updateGroupDevices_1(http: HttpClient, rootUrl: string, params: UpdateGroupDevices_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateGroupDevices_1.PATH, 'put');
  if (params) {
    rb.path('groupIdx', params.groupIdx, {});
    rb.path('harvestId', params.harvestId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateGroupDevices_1.PATH = '/api/harvests/{harvestId}/group/{groupIdx}/devices';
